import { API } from './index'
import {
  azureMarketplaceServiceUrl,
  marketplaceServiceUrl,
} from '../utils/constants'

const marketplaceUrlForCloud = (cloudType?: string) =>
  cloudType === 'AZURE' ? azureMarketplaceServiceUrl : marketplaceServiceUrl

export const getFlyOutOnboardingFormData = (accountId: string) => {
  return API.get(`${marketplaceServiceUrl}/v2/accounts/${accountId}/onboarding`)
}

export const putOnboardingFormData = ({
  accountId,
  data,
}: {
  accountId: string
  data: Record<string, unknown>
}) => {
  return API.put(
    `${marketplaceServiceUrl}/v2/accounts/${accountId}/aws/onboarding`,
    data
  )
}

export const putFlyoutNewOnboardingFormData = ({
  accountId,
  data,
  cloudType,
}: {
  accountId: string
  data: Record<string, unknown>
  cloudType?: string
}) => {
  return API.put(
    `${marketplaceUrlForCloud(cloudType)}/partners/${accountId}/onboarding`,
    data
  )
}

export const getFlyoutNewOnboardingFormData = (
  accountId: string,
  cloudType?: string
) => {
  return API.get(
    `${marketplaceUrlForCloud(cloudType)}/partners/${accountId}/onboarding`
  )
}
